import { collection, getDocs, query, orderBy, limit, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import type { TwitterUser } from '../types/twitter';

// Collection reference
const twitterUsersCollection = collection(db, 'twitter_users');

// Get all Twitter users
export const getTwitterUsers = async (limitCount = 50): Promise<TwitterUser[]> => {
  try {
    const q = query(
      twitterUsersCollection, 
      orderBy('followers_count', 'desc'), 
      limit(limitCount)
    );
    
    const querySnapshot = await getDocs(q);
    
    const users: TwitterUser[] = [];
    for (const docSnapshot of querySnapshot.docs) {
      const userData = docSnapshot.data() as TwitterUser;
      users.push({
        ...userData,
        id: docSnapshot.id
      });
    }
    
    return users;
  } catch (error) {
    console.error('Error fetching Twitter users:', error);
    return [];
  }
};

// Get a specific Twitter user by ID
export const getTwitterUserById = async (userId: string): Promise<TwitterUser | null> => {
  try {
    const docRef = doc(twitterUsersCollection, userId);
    const docSnapshot = await getDoc(docRef);
    
    if (docSnapshot.exists()) {
      return {
        ...docSnapshot.data() as TwitterUser,
        id: docSnapshot.id
      };
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching Twitter user:', error);
    return null;
  }
};

// Get a Twitter user by username
export const getTwitterUserByUsername = async (username: string): Promise<TwitterUser | null> => {
  try {
    // Try exact match first
    const exactQuery = query(
      twitterUsersCollection,
      where('username', '==', username),
      limit(1)
    );
    
    let querySnapshot = await getDocs(exactQuery);
    
    // If no exact match, try case-insensitive match
    if (querySnapshot.empty) {
      const lowercaseQuery = query(
        twitterUsersCollection,
        where('username_lower', '==', username.toLowerCase()),
        limit(1)
      );
      
      querySnapshot = await getDocs(lowercaseQuery);
    }
    
    if (!querySnapshot.empty) {
      const docData = querySnapshot.docs[0].data();
      return {
        ...docData as TwitterUser,
        id: querySnapshot.docs[0].id
      };
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching Twitter user by username:', error);
    return null;
  }
};